<template>
  <div class="empty-page">
    <div class="container overflow-hidden text-center">
      <div>
        <h1 class="display-1 font-bold">ERROR 50X</h1>
        <p class="text-xl font-bold"><span class="text-danger">Opps!</span> Something went wrong. </p>
        <p class="lead">
          The server encountered an internal error or misconfiguration and was unable to complete your request.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Error50x',
  computed: {
    ...mapState({
      customerServiceStatus: state => state.app.customerServiceStatus
    })
  },
  mounted () {
    if (this.customerServiceStatus) {
      this.$router.replace({ name: 'HomePage' }).catch(_ => { })
    }
  },
  watch: {
    customerServiceStatus (newVal) {
      if (newVal) {
        this.$router.replace({ name: 'HomePage' }).catch(_ => { })
      }
    }
  }
}
</script>

<style scoped>
.empty-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.overflow-hidden {
  overflow: hidden;
}
</style>
